import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SimulationProvider } from "@/context/SimulationContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RaffleForm from "@/pages/RaffleForm";
import RaffleManage from "@/pages/RaffleManage";
import Settings from "@/pages/Settings";
import Customers from "@/pages/Customers";
import Team from "@/pages/Team";
import History from "@/pages/History";
import Activity from "@/pages/Activity";
import Pending from "@/pages/Pending";
import Admin from "@/pages/Admin";
import PublicRaffle from "@/pages/PublicRaffle";
import Validate from "@/pages/Validate";
import TicketView from "@/pages/TicketView";
import Terminos from "@/pages/Terminos";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pendiente" element={<Pending />} />
      <Route path="/validar" element={<Validate />} />
      <Route path="/r/:raffleId" element={<PublicRaffle />} />
      <Route path="/t/:orderId" element={<TicketView />} />
      <Route path="/terminos" element={<Terminos />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard/raffles/nueva" element={<ProtectedRoute><RaffleForm /></ProtectedRoute>} />
      <Route path="/dashboard/raffles/:raffleId/editar" element={<ProtectedRoute><RaffleForm /></ProtectedRoute>} />
      <Route path="/dashboard/raffles/:raffleId" element={<ProtectedRoute><RaffleManage /></ProtectedRoute>} />
      <Route path="/dashboard/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/dashboard/clientes" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
      <Route path="/dashboard/historial" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/dashboard/actividad" element={<ProtectedRoute><Activity /></ProtectedRoute>} />
      <Route path="/dashboard/equipo" element={<ProtectedRoute><Team /></ProtectedRoute>} />
      <Route path="/gestion-interna-rifa-17" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SimulationProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </SimulationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
